export const invertedMessages = {
  'Include Associated Items': 'CERTS_INCLUDE_ASSOCIATED_ITEMS',
  'Include Associated Items (Account, Entitlements and Application Roles)':
    'CERTS_INCLUDE_ALL_ASSOCIATED_ITEMS',
  'Include Associated Items (Entitlements and Application Roles)':
    'CERTS_INCLUDE_ENT_ROLE_ITEMS',
  'Dependent parent will be approved': 'CERTS_DEPENDENT_PARENT_APPROVED',
};
